// eslint-disable-next-line @typescript-eslint/triple-slash-reference
/// <reference path="./fbpixel.d.ts" />

const PIXEL_ID = import.meta.env.VITE_FB_PIXEL_ID

/** Initialization function */
export function initFbPixel() {
    if (typeof window?.fbq !== 'function') {
        console.error('Facebook Pixel script not loaded')
        return
    }
    window.fbq('init', PIXEL_ID)
    window.fbq('track', 'PageView')
}

/** Track page view */
export function trackPageView() {
    window.fbq('track', 'PageView')
}

/**
 * Send any standard or custom event.
 * @param eventName - e.g., 'AddToCart', 'Purchase', 'MyCustomEvent'
 * @param params - a set of parameters; depends on the event
 */
export function trackEvent(
    eventName: string,
    params?: Record<string, unknown>
) {
    window.fbq('track', eventName, params || {})
}
